import { FormikFieldSetter, UploadedMedia } from "@/Shared/Types";
import { useCallback, useEffect, useState } from "react";

export const useUploadFile = (fieldValues: UploadedMedia[], formikFieldSetter: FormikFieldSetter<any>) => {

    const [input, setInput] = useState<{ name: string, files: FileList }>();

    useEffect(() => {

        const processFiles = async () => {
            if (!input?.files || !input.name) return;

            const UploadedMedias = await Promise.all(
                Array.from(input.files).map(async (file) => {
                    const thumb = await createThumbnail(file);
                    return new UploadedMedia(file, thumb, 'image');
                })
            );

            formikFieldSetter(input.name, [...fieldValues, ...UploadedMedias], true);
        };

        processFiles();

    }, [input]);


    const upload = (event: React.ChangeEvent<HTMLInputElement>, name: string): void => {
        const files = event.currentTarget.files;
        files && setInput({ name, files });
    }

    const createThumbnail = useCallback(async (
        originalFile: File,
        maxWidth = 300,
        maxHeight = 300
    ): Promise<File> => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const url = URL.createObjectURL(originalFile);

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                if (!ctx) {
                    reject('Canvas not supported');
                    return;
                }

                let { width, height } = img;

                const ratio = Math.min(maxWidth / width, maxHeight / height);
                width *= ratio;
                height *= ratio;

                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob((blob) => {
                    if (!blob) return reject('Failed to create blob');

                    const originalName = originalFile.name;
                    const nameWithoutExtension = originalName.replace(/\.[^/.]+$/, "");
                    const smallFileName = `thumb_${nameWithoutExtension}.jpg`;

                    const thumbnailFile = new File([blob], smallFileName, { type: 'image/jpeg' });

                    resolve(thumbnailFile);
                    URL.revokeObjectURL(url);
                }, 'image/jpeg', 0.75);
            };

            img.onerror = reject;
            img.src = url;
        });
    }, []);


    return {
        upload
    }
}